import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';
// import RNFetchBlob from 'rn-fetch-blob' ;





const dispatchRequestUpdateProfile = updateProfileData => ({
        type:ActionTypes.REQUEST_UPDATE_PROFILE, 
        updateProfileData
})

const dispatchReceivedUpdateProfile = res =>({
    type:ActionTypes.RECEIVED_UPDATE_PROFILE,
    res
})

const dispatchErrorUpdateProfile = (err) => ({
    type:ActionTypes.ERROR_UPDATE_PROFILE,
    err
})

const dispatchClearUpdateProfile= () => ({
    type: ActionTypes.CLEAR_UPDATE_PROFILE
})

export const clearUpdateProfileData = () => dispatchClearUpdateProfile();

export const updateProfile = (updateProfileData) => dispatch => {

    dispatch(dispatchRequestUpdateProfile(updateProfileData));
    delete updateProfileData.gender;
    console.log(updateProfileData, 'updated profle data');

    // const data = {
    //     first_name: 'light',
    //     last_name: 'yagami',
    //     // email: 'testmail@mail.com',
    //     city: 'warangal',
    //     address: 'mars'
    // }

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/update_profile`,
                data: {...updateProfileData},
                headers: {
                    'Authorization': `Bearer ${authKey}`,
                    'Content-Type': 'application/json'
                }
            }
            // fetch(options.url, options)
            //     .then(res => res.json())
            //     .then(data =>  dispatchReceivedUpdateProfile(data))
            //     .catch(e  => dispatchErrorUpdateProfile(e));

            return axios(options)
                .then(res => dispatch(dispatchReceivedUpdateProfile(res)))
                .catch(e => dispatch(dispatchErrorUpdateProfile(e)))

        })
        .catch(e => dispatch(dispatchErrorUpdateProfile(e.response)));
}

///getUpdateProfile



const dispatchRequestGetUpdateProfile = data => ({
    type: ActionTypes.REQUEST_GET_UPDATE_PROFILE,
    data
})

const dispatchReceivedGetUpdateProfile = res => ({
    type: ActionTypes.RECEIVED_GET_UPDATE_PROFILE,
    res
})

const dispatchErrorGetUpdateProfile = err => ({
    type: ActionTypes.ERROR_GET_UPDATE_PROFILE,
    err
})

const dispatchClearGetUpdateProfile = () => ({
    type: ActionTypes.CLEAR_GET_UPDATE_PROFILE
})

export const clearGetUpdateProfile = () => dispatchClearGetUpdateProfile();

export const getUpdateProfile = () => dispatch => {

    dispatch(dispatchRequestGetUpdateProfile()); 

    getUserToken()
    .then( authKey => {
        const options = {
            method: 'post',
            url: `${baseUrl}/api/user_profile`,
            headers: {
                'Authorization': `Bearer ${authKey}`
            }                   
        }
        return axios(options)
        .then(({data}) => {                         
            dispatch(dispatchReceivedGetUpdateProfile(data))
        })
    }).catch(e => dispatch(dispatchErrorGetUpdateProfile(e)));   
}



const dispatchRequestUploadProfile = uploadProfileData => ({
    type:ActionTypes.REQUEST_UPLOAD_PROFILE,
    uploadProfileData
})

const dispatchReceivedUploadProfile = res =>({
    type:ActionTypes.RECEIVED_UPLOAD_PROFILE,
    res
})

const dispatchErrorUploadProfile = (err) => ({
    type:ActionTypes.ERROR_UPLOAD_PROFILE,
    err
})

const dispatchClearUploadProfile= () => ({
    type: ActionTypes.CLEAR_UPLOAD_PROFILE
})

export const clearUploadProfileData = () => dispatchClearUploadProfile();


export const uploadProfilePic = (uploadProfileData, fileName) => dispatch => {

    dispatch(dispatchRequestUploadProfile(uploadProfileData));    
    // const imagePath = Platform.OS === "android" ? uploadProfileData : uploadProfileData.replace("file://", "");


    // const data = {
    //     first_name: 'light',
    //     last_name: 'yagami',
    //     // email: 'testmail@mail.com',
    //     city: 'warangal',
    //     address: 'mars'
    // }

    getUserToken()
        .then( async (authKey) => {

            // const options = {
            //     method: 'post',
            //     url: `${baseUrl}/api/UPLOAD_PROFILE`,
            //     data: {...uploadProfileData},
            //     headers: {
            //         'Authorization': `Bearer ${authKey}`,
                    
            //     }
            // }
            
            // const photo = await AsyncStorage.getItem('profilePic');            
                // RNFetchBlob.fetch('POST', `${baseUrl}/api/edit_profile_pic`, {
                //     Authorization : `Bearer ${authKey}`,

                //     'Content-Type' : 'multipart/form-data',
                // }, [
                //     // append field data from file path
                //     {
                //     name : 'profile_pic',
                //     filename : 'avatar.jpg',
                //     type: 'image/jpeg',
                //     // Change BASE64 encoded data to a file path with prefix `RNFetchBlob-file://`.
                //     // Or simply wrap the file path with RNFetchBlob.wrap().
                //     // data: RNFetchBlob.wrap(imagePath)
                //     }                
                // ]).then(({data}) => {  
                //     let _data = data;                
                //     if(typeof data === 'string') _data = JSON.parse(data);
                //     dispatch(dispatchReceivedUploadProfile(_data))
                // }).catch((e) => {
                //     console.log(e, 'error from upload profile rn fetch', e.response);  
                //     dispatch(dispatchErrorUploadProfile(e.response));
                // })
            

            // axios(options)
            //     .then(res => dispatchReceivedUploadProfile(res))
            //     .catch(e => dispatchErrorUploadProfile(e))

        })
        .catch(e =>{
            // console.log(e, e.response);
            dispatch(dispatchErrorUploadProfile(e.response))
        });    
}